export const CONTACT_NUMBER_URL = '1300 513 677';
export const MOBILE_URL = 'tel:1300513677';
